import { Store } from 'redux';

/**
 * @description: A container class to do dependecy injection with redux store
 * @author: Jean Faverie
 * @deprecated: Do not use if possible
 */
export class DangerousStore {
  public static get store(): any {
    if (!DangerousStore.Store) {
      throw new Error('Uninitialized Store! Please set store before');
    }

    return DangerousStore.Store;
  }
  public static set store(store: any) {
    DangerousStore.Store = store;
  }

  public static get persistor(): any {
    if (!DangerousStore.Persistor) {
      throw new Error('Uninitialized Store! Please set store before');
    }

    return DangerousStore.Persistor;
  }
  public static set persistor(persistor: any) {
    DangerousStore.Persistor = persistor;
  }

  public static async purge() {
    return DangerousStore.persistor.purge();
  }
  private static Store: Store<any>;
  private static Persistor: Store<any>;
}
